var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutCert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1696_688)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1696_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6092 0.590765C35.1344 0.555678 34.6497 0.711546 34.2715 1.06872L34.2645 1.07223C33.5617 1.73439 33.5305 2.82077 34.1492 3.56391C38.5735 8.8738 41.2571 15.6982 41.2571 23.1529C41.2571 30.2765 38.8046 36.8195 34.729 42.0215C34.1317 42.7844 34.1934 43.8724 34.9176 44.5166C35.6723 45.186 36.8485 45.1168 37.4744 44.3233C42.0668 38.497 44.8337 31.151 44.8337 23.1529C44.8337 14.8165 41.8307 7.18751 36.8806 1.25146C36.5471 0.851108 36.084 0.625852 35.6092 0.590765ZM29.0951 6.7479C28.615 6.71079 28.1217 6.86599 27.7399 7.22585C27.0764 7.85202 26.9616 8.89955 27.5338 9.61209C30.5167 13.3188 32.3155 18.0229 32.3155 23.1529C32.3155 28.0453 30.6769 32.5479 27.939 36.1701C27.3846 36.9024 27.523 37.9516 28.2079 38.5598C29.002 39.2652 30.2101 39.1086 30.8485 38.2575C34.0049 34.0471 35.8921 28.8227 35.8921 23.1529C35.8921 17.2006 33.8161 11.7374 30.37 7.42618C30.0418 7.01503 29.5753 6.78501 29.0951 6.7479ZM22.574 12.9156C22.0865 12.8758 21.5816 13.0362 21.1944 13.4005L21.1839 13.4076C20.533 14.0212 20.4346 15.0248 20.9604 15.7482C22.4751 17.8282 23.3739 20.3837 23.3739 23.1529C23.3739 25.0422 22.9479 26.8281 22.2003 28.4349L5.99716 14.4971C5.37304 13.9609 4.42098 14.134 4.01324 14.852C2.68452 17.1966 1.91406 19.9012 1.91406 22.7909C1.91406 25.6231 2.65247 28.2788 3.93291 30.5927C4.49087 31.6004 5.86578 31.7833 6.70271 30.9934L6.7062 30.9864C7.29277 30.4321 7.44712 29.5481 7.05548 28.8391C6.06296 27.0451 5.4907 24.9879 5.4907 22.7909C5.4907 21.5764 5.67697 20.4078 6.00065 19.2976L21.893 32.979C22.476 33.481 23.3475 33.3538 23.8035 32.733C25.776 30.0502 26.9505 26.7408 26.9505 23.1529C26.9505 19.5902 25.7947 16.2993 23.8454 13.6255C23.5325 13.1955 23.0616 12.9554 22.574 12.9156Z",
    fill: "#212121"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1696_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0657,
    height: 45.0657,
    fill: "white",
    transform: "translate(0.839844 0.585938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1696_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9197,
    height: 45.0657,
    fill: "white",
    transform: "translate(1.91406 0.585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCert);
export default __webpack_public_path__ + "static/media/about-cert.9d76a6682da9fa37c161e60f47291a16.svg";
export { ForwardRef as ReactComponent };